import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/artofyou/builds/rCvyCwqKt/0/sapient/art-of-you-website-front-end/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/artofyou/builds/rCvyCwqKt/0/sapient/art-of-you-website-front-end/src/page-components/InnerDoc/InnerDoc.module.scss");
